import { Injectable, inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Observable, Subject } from 'rxjs';
import { Case, CaseInput } from '../../../core/services/case.model';
import { NewCaseModalComponent } from './new-case-modal.component';

@Injectable({ providedIn: 'root' })
export class CaseModalService {
  private overlay = inject(Overlay);

  open(existing: Case | null = null): Observable<CaseInput | null> {
    const result = new Subject<CaseInput | null>();

    const ref: OverlayRef = this.overlay.create({
      hasBackdrop: true,
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });

    const portal = new ComponentPortal(NewCaseModalComponent);
    const compRef = ref.attach(portal);
    compRef.instance.existing = existing;
    compRef.instance.submit.subscribe((input: CaseInput) => {
      result.next(input);
      result.complete();
      ref.dispose();
    });
    compRef.instance.cancel.subscribe(() => {
      result.next(null);
      result.complete();
      ref.dispose();
    });
    ref.backdropClick().subscribe(() => {
      result.next(null);
      result.complete();
      ref.dispose();
    });

    return result.asObservable();
  }
}
